import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserService } from './user.service';
import { loadUserConfiguration, loadUserConfigurationSuccess, loadUserConfigurationFailure, loadUserConfigurationOverwrite } from './user.actions';
@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private userService: UserService,
    private router: Router
  ) { }

  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserConfiguration),
      switchMap(() =>
        this.userService.getUserConfiguration().pipe(
          concatMap((user) => [
            loadUserConfigurationSuccess({ user }),
            loadUserConfigurationOverwrite({ user })
          ]),
          catchError((error) => of(loadUserConfigurationFailure({ error: error.message })))
        )
      )
    )
  );

  loadUserOverwrite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserConfigurationOverwrite),
      map(({ user }) => {
        if (user?.generalFreightEnabled) {
          this.router.navigate(['/app/order/home']);
        } else if (user?.specialisedFreightEnabled) {
          this.router.navigate(['/app/jobbing/home']);
        } else if (user?.containersEnabled) {
          this.router.navigate(['/app/containers/home']);
        } else {
          this.router.navigate(['/app/dashboard']);
        }
      })
    ),
    { dispatch: false }
  );
}
